import * as THREE from "three";

// Shared placeholder material — dark grey, assigned synchronously so GLBs
// never render white while their real textures are loading.
export const darkDefaultMat = new THREE.MeshStandardMaterial({
  color: "#1a1a1a",
  roughness: 0.7,
});

export function applyDarkDefault(scene) {
  scene.traverse((obj) => {
    if (obj.isMesh) {
      obj.material = darkDefaultMat;
    }
  });
}
